<template>
  <el-dialog :title="title" :visible.sync="outerVisible" width="70%" append-to-body>
    <div class="d-flex queryClass">
      <el-row :gutter="24">
        <el-col :xl="24" :lg="16" class="d-flex justify-content-between w100p">
          <div class="d-flex align-items-center">
            <el-input v-model="queryParam.className" class="mb10" style="width: 240px" placeholder="请输入产品名称"
              clearable></el-input>
            <el-input v-model="queryParam.partNumber" class="mb10 ml10" style="width: 240px" clearable
              placeholder="请输入存货编码" v-if="companyName.includes('五洲')"></el-input>
            <el-button class="ml10 mb10" type="primary" @click="handleSearch">搜索</el-button>
            <el-button class="ml10 mb10" type="primary" @click="reset">重置</el-button>
            <el-button class="ml10 mb10" type="primary" @click="handleExport">导出</el-button>
          </div>
        </el-col>
      </el-row>
    </div>
    <el-table :data="tableData" style="width: 100%;margin-bottom: 20px;" border>
      <el-table-column prop="className" align="center" label="产品名称">
      </el-table-column>
      <el-table-column prop="inventCode" align="center" label="存货编码" v-if="companyName.includes('五洲')">
      </el-table-column>
      <el-table-column prop="num" align="center" :label="'库存数量' + (tableUnit ? '(' + tableUnit + ')' : '')">
        <template slot-scope="scope">
          {{formatNumber(scope.row.num)}}
        </template>
      </el-table-column>
      <!-- 重量 -->
      <el-table-column prop="weight" align="center" :label="'库存重量' + (tableUnit ? '(' + tableUnit + ')' : '')">
        <template slot-scope="scope">
          {{formatNumber(scope.row.weight)}}
        </template>
      </el-table-column>
    </el-table>
    <div class="pageBox">
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="pageNum" :page-sizes="[10, 15, 20]" layout="total, sizes, prev, pager, next, jumper" class=""
        :total="total" :pager-count="5" />
    </div>

    <!-- 导出预览对话框 -->
    <el-dialog title="导出预览" :visible.sync="exportDialogVisible" :close-on-click-modal="false" :destroy-on-close="true"
      append-to-body width="80%">
      <div class="export-tips">共 {{exportTotal}} 条数据，确认导出以下数据：</div>
      <el-table :data="exportPreviewData" style="width: 100%;margin-bottom: 20px;" border max-height="400">
        <el-table-column prop="className" align="center" label="产品名称">
        </el-table-column>
        <el-table-column prop="inventCode" align="center" label="存货编码" v-if="companyName.includes('五洲')">
        </el-table-column>
        <el-table-column prop="num" align="center" :label="'库存数量' + (tableUnit ? '(' + tableUnit + ')' : '')">
          <template slot-scope="scope">
            {{formatNumber(scope.row.num)}}
          </template>
        </el-table-column>
        <el-table-column prop="weight" align="center" :label="'库存重量' + (tableUnit ? '(' + tableUnit + ')' : '')">
          <template slot-scope="scope">
            {{formatNumber(scope.row.weight)}}
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="exportDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmExport" :loading="exportLoading">确认导出</el-button>
      </span>
    </el-dialog>
  </el-dialog>
</template>
<script>
  import { fetchClassInfo } from '@/api/storeWarehouse.js'
  import { export_json_to_excel } from "@/excel/Export2Excel.js";
  export default {
    props: {},
    components: {},
    data() {
      return {
        userInfo: '',
        companyName: '',
        title: '库存产品',
        tableData: [],
        loading: false,
        pageSize: 10,
        pageNum: 1,
        total: 1,
        outerVisible: false,
        queryParam: {
          partNumber: '',
          className: ''

        },
        warehouseId: '',
        warehouseName: '',
        exportLoading: false,
        exportDialogVisible: false,
        exportPreviewData: [],
        exportTotal: 0,
        tableUnit: ''
      }
    },
    created() {
      let userInfo = JSON.parse(localStorage.getItem('info'));
      this.userInfo = userInfo
      if (this.userInfo.companyList) {
        this.companyName = this.userInfo.companyList[0].companyName
      }

    },
    mounted() {
    },
    methods: {
      openDialog(item) {
        this.warehouseId = item.id
        this.warehouseName = item.name
        this.getList()
        this.outerVisible = true
      },
      handleSizeChange(num) {
        this.pageSize = num;
        this.pageNum = 1;
        this.getList();
      },
      handleCurrentChange(num) {
        this.pageNum = num;
        this.getList();
      },
      reset() {
        this.pageNum = 1
        this.queryParam.className = ''
        this.queryParam.partNumber = ''
        this.getList()
      },
      handleSearch() {
        this.pageNum = 1
        this.getList()
      },
      getList() {
        let params = {
          ...this.queryParam,
          pageSize: this.pageSize,
          pageNum: this.pageNum,
          warehouseId: this.warehouseId
        }
        fetchClassInfo(params).then(res => {
          this.tableData = res.data.list
          this.total = res.data.total
          // 设置单位（取第一条数据的单位）
          if (res.data.list && res.data.list.length > 0) {
            this.tableUnit = res.data.list[0].unit || ''
          }
        })
      },
      // 格式化数字，去除末尾的0
      formatNumber(num) {
        if (!num && num !== 0) return '0'
        // 转为数字再转回字符串，自动去除末尾0
        return parseFloat(num).toString()
      },
      exportWarehouseData(item) {
        // 直接从外部调用导出
        this.warehouseId = item.id
        this.warehouseName = item.name
        this.getExportData()
      },
      handleExport() {
        // 从对话框内调用导出
        this.getExportData()
      },
      getExportData() {
        // 获取所有数据（不带分页）
        let params = {
          ...this.queryParam,
          warehouseId: this.warehouseId,
          pageNum: 1,
          pageSize: 99999
        }

        fetchClassInfo(params).then(res => {
          this.exportPreviewData = res.data.list
          this.exportTotal = res.data.list.length
          this.exportDialogVisible = true
        })
      },
      confirmExport() {
        this.exportLoading = true

        // 获取第一条数据的单位（假设所有数据单位相同）
        const firstItem = this.exportPreviewData[0] || {}
        const unit = firstItem.unit || ''

        // 准备导出数据 - 表头（带单位）
        const th = ['产品名称']
        if (this.companyName.includes('五洲')) {
          th.push('存货编码')
        }
        th.push('库存数量' + (unit ? '(' + unit + ')' : ''), '库存重量' + (unit ? '(' + unit + ')' : ''))

        // 准备导出数据 - 表格数据（二维数组格式，不带单位）
        const tb = this.exportPreviewData.map(item => {
          const row = []
          row.push(item.className || '')
          if (this.companyName.includes('五洲')) {
            row.push(item.inventCode || '')
          }
          row.push(this.formatNumber(item.num))
          row.push(this.formatNumber(item.weight))
          return row
        })

        // 导出Excel
        const fileName = this.warehouseName + '库存数据'
        export_json_to_excel(th, tb, fileName)

        this.exportLoading = false
        this.exportDialogVisible = false
        this.$message.success('导出成功')
      }
    }
  }
</script>
<style scoped>
  .lookItem {
    color: #409eff;
    cursor: pointer;
  }

  .export-tips {
    font-size: 14px;
    color: #606266;
    margin-bottom: 15px;
    line-height: 1.5;
  }
</style>